<h1 mat-dialog-title>{{ "dg.support-request.Sure" | translate }}</h1>
<mat-dialog-actions class="justify-content-end">
  <button mat-raised-button mat-dialog-close class="me-2">
    {{ "dg.support-request.No" | translate }}
  </button>
  <button mat-raised-button color="primary" [mat-dialog-close]="true">
    {{ "dg.support-request.Yes" | translate }}
  </button>
</mat-dialog-actions>
